import styled from "styled-components";
import SideImage from "../../assets/images/the_pepsico_way.png";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 600px;
  width: 100%;
  max-width: 800px;
  background-image: url(${SideImage});
  background-size: contain;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;

  @media (max-width: 500px) {
    background-image: none;
  }

  form {
    margin-left: auto;

    @media (max-width: 500px) {
      margin: 0 auto;
    }
  }

  form > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    min-width: 350px;
    width: 350px;
    min-height: 600px;

    background-color: white;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    padding: 0 20px;

    @media (max-width: 600px) {
      border-radius: 16px;
    }
  }
`;